import { Injectable } from '@angular/core';
import { FiFormService } from '@fi-app/fi-form/fi-form.service';
import { ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { BehaviorSubject } from 'rxjs';
import { IForm } from '@fi-shared/fi-form-shared/fi-form-shared';
import { FiSignalRService } from '@fi-shared/fi-signal-r/fi-signal-r.service';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { IFormListParameter } from '@fi-app/fi-form/fi-form';

@Injectable()
export class FiFormTodoService {
    constructor(
        private fiFormService: FiFormService,
        private fiSignalRService: FiSignalRService,
        private fiSignalRHelperService: FiSignalRHelperService,
    ) {
        this.fiSignalRHelperService.initialTodoForms$.subscribe((v) => this._todoForms$.next(v));
    }

    private _todoForms$ = new BehaviorSubject<IForm[]>([]);
    get todoForms$() {
        return this._todoForms$.asObservable();
    }
    get todoForms() {
        return this._todoForms$.value;
    }

    initForSystemNotifications() {
        this.fiSignalRHelperService.startUpdateItemsEventProcessing(
            ObjectTypes.Form,
            () => this._todoForms$.value,
            (formIds) => this.fiFormService.getForms(this.getParameterForFormsTodo(formIds)),
            (newTodoForms) => this._todoForms$.next(newTodoForms),
        );
    }

    private getParameterForFormsTodo(formIds?: number[]): IFormListParameter {
        return {
            FilterType: SideListOptionType.FormsInToDo,
            Ids: formIds,
        };
    }
}
